<script setup lang="ts">
const emit = defineEmits<{
  click: [];
}>();

const onClick = (): void => {
  emit("click");
};
</script>

<template>
  <button
    type="button"
    class="btn btn-warning fw-bold py-2 px-3"
    :title="$t('How automarking works?')"
    @click.prevent.stop="onClick"
  >
    <UiIcon fa="fa fa-question-circle" /> {{ $t("How automarking works?") }}
  </button>
</template>
